var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { DialogTabs } from "../../../../../Shared/components/ItemDetail/ItemDetail-types";
import { handleRecipeIncrement_V2 } from "./handleRecipeIncrement_V2";
import { handleToggleRecipeSelection_V2 } from "./handleToggleRecipeSelection_V2";
import { onCustomizeClick_V2 } from "./onCustomizeClick_V2";
export const openCustomizeModal_V2 = ({ assignmentCount, companyUsesKlaviyo, createKlaviyoEvent, datadogLog, isSingleSelect, logReactPixel, reactPixelKey, recipeHandlerProps_Three: RHP, setDialogContentMode, setIsCustomizeModalOpen, setIsDetailDialogOpen, setOpenFromIncrement, }) => __awaiter(void 0, void 0, void 0, function* () {
    // This function sets the meals (Order Flow) and days (My Meals) in the customization context
    yield onCustomizeClick_V2(Object.assign({}, RHP));
    if (!!setDialogContentMode)
        setDialogContentMode(DialogTabs.CUSTOMIZE);
    if (!!setIsDetailDialogOpen)
        setIsDetailDialogOpen(true);
    // Only open the customize modal when there are no assignments
    if (assignmentCount === 0) {
        if (isSingleSelect) {
            yield handleToggleRecipeSelection_V2(Object.assign(Object.assign({}, RHP), { companyUsesKlaviyo,
                createKlaviyoEvent,
                datadogLog,
                logReactPixel,
                reactPixelKey }));
        }
        else {
            yield handleRecipeIncrement_V2(Object.assign(Object.assign({}, RHP), { companyUsesKlaviyo,
                createKlaviyoEvent,
                datadogLog,
                logReactPixel, createNewAssignment: true, shouldSetAssignmentId: true }));
        }
        setIsCustomizeModalOpen(true);
        if (setOpenFromIncrement)
            setOpenFromIncrement(true);
    }
});
